import React from 'react';
import Icons from './Icons';

export default function SwiperNavigationButton({ clickHandler, type, className, icon }) {
  switch (type) {
    case 'next':
      return (
        <button type="button" aria-label="arrow-right" onClick={clickHandler} className={className}>
          <div
            className=" text-white md:w-[48px] w-[43px] md:h-[48px] h-[43px] flex
            items-center justify-center mr-[16px] prev"
          >
            <Icons icon={icon} />
          </div>
        </button>
      );
    case 'prev':
      return (
        <button type="button" aria-label="arrow-left" onClick={clickHandler} className={className}>
          <div
            className=" text-white md:w-[48px] w-[43px] md:h-[48px] h-[43px] flex
            items-center justify-center next"
          >
            <Icons icon={icon} />
          </div>
        </button>
      );

    default:
      return null;
  }
}
